import script from "./ListPapers.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPapers.vue?vue&type=script&setup=true&lang=js"

import "./ListPapers.vue?vue&type=style&index=0&id=30bef712&lang=scss"

const __exports__ = script;

export default __exports__